export default __webpack_public_path__ + "static/media/f17f968edf3f8772f95448c4d0b86ac91581620636049.3c8ff8fd.webp";